import { render } from "./ContactMessageThread.vue?vue&type=template&id=0d1246af"
import script from "./ContactMessageThread.vue?vue&type=script&lang=js"
export * from "./ContactMessageThread.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__